import { notificationStore } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { AdditionalResponseCode } from '../enums';

const { parseNumberByPrecision } = require('@pascal/pascal-core');

export const checkMaxAutoCashOutValue = (betAmount, maxWin, minOdd) => {
  if (betAmount > 0) {
    const maxAutoCashOutOdd = maxWin / betAmount;
    gameConfigStore.setMaxAutoCashOutOdd(parseNumberByPrecision(1, maxAutoCashOutOdd, 1));
    return maxAutoCashOutOdd === maxAutoCashOutOdd < minOdd
      ? minOdd
      : parseNumberByPrecision(1, maxAutoCashOutOdd, 1);
  }
  return null;
};

export const setDefaultValueNumpad = (value, action, limits, responseType) => {
  const { minValue, maxValue } = limits;
  const currentValue = +value;
  if (currentValue < minValue) {
    action(minValue);
    notificationStore.setNotificationType({
      responseCode: AdditionalResponseCode[responseType.InValidMin],
    });
  } else if (maxValue && currentValue > maxValue) {
    action(maxValue);
    notificationStore.setNotificationType({
      responseCode: AdditionalResponseCode[responseType.InValidMax],
    });
  } else {
    action(currentValue);
  }
};
